import { Permission, PermissionAccessLevel, RoleGroup, User } from '../models';
import { IGroupConfig } from '../groups/igroups.config';

export class PermissionChecker {

	private _permissionMap: Map<string, Permission> = new Map<string, Permission>();

	constructor(private _environment: string, private igroupConfig: IGroupConfig) {
		igroupConfig.permissions.forEach(
			(rawPermission: Permission) => {
				const permission: Permission = new Permission(rawPermission, this._environment);
				this._permissionMap.set(permission.name, permission);
			}
		);
	}

	getUsersPermissions(user: User): PermissionAccessLevel[] {
		const userAccess: PermissionAccessLevel[] = [];
		this._permissionMap.forEach(
			(permission: Permission) => {
				const access: PermissionAccessLevel | null = permission.getUserAccessLevel(user);
				if (access) {
					userAccess.push(access);
				}
			}
		);
		return userAccess;
	}

	permitted(user: User, privilege: string): boolean {
		let authorized = false;

		if (privilege == null) {
			authorized = true;
		} else {
			if (user && this.checkPrivilege(user, RoleGroup.ADMIN_GROUP_NAME)) {
				if (privilege.indexOf('!') < 0) {
					authorized = true;
				} else {
					authorized = false;
				}

			} else if (user && privilege && privilege.length > 0) {
				if (privilege.indexOf('|') > 0) {
					const privilegeStrings: string[] = privilege.split('|');

					for (const privilegeString of privilegeStrings) {
						let token: string = privilegeString.trim();
						if (token.charAt(0) === '!') {
							token = token.substring(1);
							if (!this.checkPrivilege(user, token)) {
								authorized = true;
								break;
							}
						} else {
							if (this.checkPrivilege(user, token)) {
								authorized = true;
								break;
							}
						}

					}
				} else {
					const privilegeStrings: string[] = privilege.split('&');
					let allTokensPositive = true;

					for (const privilegeString of privilegeStrings) {
						let token: string = privilegeString.trim();
						if (token.charAt(0) === '!') {
							token = token.substring(1);
							if (this.checkPrivilege(user, token)) {
								allTokensPositive = false;
								break;
							}
						} else {
							if (!this.checkPrivilege(user, token)) {
								allTokensPositive = false;
								break;
							}
						}
					}
					if (allTokensPositive) {
						authorized = true;
					}
				}
			}
		}
		return authorized;
	}

	private checkPrivilege(user: User, token: string, tenurize = true): boolean {
		let allowed = false;
		const requiredPermission: any = { name: token, accessLevel: null };

		if (token.indexOf('.') > 0) {
			const tokens: string[] = token.split('.');
			if (tokens.length > 1) {
				requiredPermission.name = tokens[0];
				requiredPermission.accessLevel = tokens[1];
			}
		}

		const permission: Permission = this._permissionMap.get(requiredPermission.name);
		if (permission) {

			for (const group of user.groups) {
				if (permission.permitted(group, requiredPermission.accessLevel, tenurize)) {
					allowed = true;
					break;
				}
			}
		}
		return allowed;
	}

	get environment(): string {
		return this._environment;
	}

	get permissions(): Permission[] {
		return [...this._permissionMap.values()];
	}
}
